import { Component, Inject, OnInit, ViewEncapsulation } from "@angular/core";
import {
  MatDialogRef,
  MAT_DIALOG_DATA,
  MatTabChangeEvent,
} from "@angular/material";
import { GameSettingsService } from "../../game-settings.service";

@Component({
  selector: "app-match-editor",
  templateUrl: "./match-editor.component.html",
  styleUrls: ["./match-editor.component.scss"],
  encapsulation: ViewEncapsulation.None,
})
export class MatchEditorComponent implements OnInit {
  dialogTitle: string = "Match Editor";
  prizeIndex: number;
  s3BucketUrl: string;
  cashPrizeImagesOptions: any;

  cashPrizeValue: string = "";

  checkExactOrEliminationInPrizes: any;
  assignEmojisToInviteImageArt: any;

  droppedEmojisForPrize: any[] = [];

  constructor(
    public gameSettingsService: GameSettingsService,
    public dialogRef: MatDialogRef<MatchEditorComponent>,
    @Inject(MAT_DIALOG_DATA) private data: any
  ) {
    this.prizeIndex = this.data.prizeIndex;
    this.s3BucketUrl = this.data.s3BucketUrl;
    this.cashPrizeImagesOptions = this.data.cashPrizeImagesOptions;
    this.checkExactOrEliminationInPrizes =
      this.data.checkExactOrEliminationInPrizes;
    this.assignEmojisToInviteImageArt = this.data.assignEmojisToInviteImageArt;
  }

  ngOnInit() {
    if (this.gameSettingsService.winPattern[this.prizeIndex] === undefined)
      this.gameSettingsService.winPattern[this.prizeIndex] = {
        index: 0,
        type: "exact match",
        cashPrizeImages: [],
        cashPrizeValue: "",
        prizeConfetti: {
          color_1: "#7969ec",
          color_2: "#60e0e6",
          color_3: "#69ddec",
          color_4: "#b0e0e6",
          color_5: "#ff85de",
          color_6: "#00e1ff",
          numberInput: 10,
          radius: 10,
          type: "color",
        },
      };
  }

  shuffle(index) {
    if (this.data && this.data.shuffle) {
      this.data.shuffle(index);
    }
  }

  extraImagesDelete(index, item) {
    if (this.data && this.data.shuffle) {
      this.data.extraImagesDelete(index, item);
    }
  }

  getSelectedIndex(): number {
    if (this.gameSettingsService.winPattern[this.prizeIndex] === undefined) return 0;
    if (this.gameSettingsService.winPattern[this.prizeIndex].prizeConfetti === undefined) return 0;
    const prizeConfettiType =
      this.gameSettingsService.winPattern[this.prizeIndex].prizeConfetti.type;

    switch (prizeConfettiType) {
      case "color":
        return 0;
      case "emoji":
        return 1;
      case "canvas":
        return 2;
      default:
        return 0; // Default to the first tab (Color Confetti) if the type is not recognized
    }
  }

  /**
   * Handles the tab change event.
   * Sets the flag in the prizeConfetti array based on the selected tab index.
   * @param $event - The tab change event.
   */
  onTabChange(event: MatTabChangeEvent) {
    const selectedIndex = event.index;
    const prizeConfetti =
      this.gameSettingsService.prizeConfetti[this.prizeIndex];

    switch (selectedIndex) {
      case 0: // Color Confetti tab
        prizeConfetti.type = "color";
        break;
      case 1: // Emoji Confetti tab
        prizeConfetti.type = "emoji";
        break;
      case 2: // Canvas Confetti tab
        prizeConfetti.type = "canvas";
        break;
      default:
        break;
    }
  }
}
